<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">类型：</span>
					<el-select v-model="search_type" class="b_inp">
						<el-option :value="'person'" label="person"></el-option>
						<el-option :value="'mechanism'" label="mechanism"></el-option>
					</el-select>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="totalTime"
						label="总次数"
					>
					</el-table-column>
					<el-table-column
						prop="consumeTime"
						label="消费次数"
					>
					</el-table-column>
					<el-table-column
						prop="remainTime"
						label="剩余次数"
					>
					</el-table-column>
					<el-table-column
						prop="rechargeTime"
						label="充值记录总次数"
					>
					</el-table-column>
					<el-table-column
						prop="flag"
						label="产品类型"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				total: 0,
				currentPage: 1,

				search_type: 'person'
			}
		},
		methods: {
			/************************ @Events *******************************/
			// 点击查询
			handleSearchClick () {
				this.getList();
			},
			// 切换页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			/************************ @Function *******************************/
			// 获取数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					type: that.search_type,
					limit: 10,
					pageNum: that.currentPage
				};
				Api.findRechargeAccountUnusual(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								uid: _o.uid,
								name: _o.uname || '',
								totalTime: _o.rtotalTime || 0,
								consumeTime: _o.ctotalTime || 0,
								remainTime: _o.rcTime || 0,
								rechargeTime: _o.countNum || 0,
								flag: _o.uversionFlag
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
</style>
